class Release {
  constructor (data) {
    this.id = data ? data.id : ''
    this.description = data ? data.description : ''
    this.created_at = data ? data.created_at : ''
  }
}

export default Release



// WEBPACK FOOTER //
// ./src/models/Release.js